import { config } from '../../../data';

const configFunc = (state = config) => state;

export default configFunc;